import { render, staticRenderFns } from "./ExtraToy.vue?vue&type=template&id=94b54eae&"
import script from "./ExtraToy.vue?vue&type=script&lang=js&"
export * from "./ExtraToy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports